import axios from 'axios'
import notifService from '../../services/notifService'

export const getMockGps = async ({ commit }, pagination) => {
  return await axios
    .get('/cms/developer/mock-gps', {
      params: {
        filter: pagination.filter,
        page: pagination.current_page,
        division: pagination.division
      }
    })
    .then(response => {
      commit('getMockGps', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      console.log('err: ', error)
      return error
    })
}

export const getFailJobs = async ({ commit }, pagination) => {
  return await axios
    .get('/cms/developer/queue/jobs/fail', {
      params: {
        page: pagination.current_page
      }
    })
    .then(response => {
      commit('getFailedJobs', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      console.log('err: ', error)
      return error
    })
}

export const getJobs = async ({ commit }, pagination) => {
  return await axios
    .get('/cms/developer/queue/jobs', {
      params: {
        page: pagination.current_page
      }
    })
    .then(response => {
      commit('getJobs', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      console.log('err: ', error)
      return error
    })
}

export const toRetryJob = async (context, val) => {
  return await axios
    .get('/cms/developer/queue/retry', {
      params: {
        command: val
      }
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      console.log('err: ', error)
      return error
    })
}

export const toRemoveJob = async (context, val) => {
  return await axios
    .get('/cms/developer/queue/remove', {
      params: {
        command: val
      }
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      console.log('err: ', error)
      return error
    })
}

export const artisan = async (context, val) => {
  return await axios
    .get('/cms/developer/artisan', {
      params: {
        val: val
      }
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      console.log('err: ', error)
      return error
    })
}

export const mockExcel = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/developer/mock-gps/excel', {
      params: pagination,
      responseType: 'blob'
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'mock-gps.xlsx')
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}
